export default __webpack_public_path__ + "static/media/cda.d81635cf.png";